import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { COACH_CONFIG } from '../../coachconfig';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);
  const [error, setError] = useState('');
  const [giftSubmitted, setGiftSubmitted] = useState(false);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) {
      setError('No session ID found.');
      setLoading(false);
      return;
    }
    setSession(sessionId);

    // Try to submit the gift if pendingGift exists
    const pendingGift = localStorage.getItem('pendingGift');
    if (pendingGift) {
      const giftData = JSON.parse(pendingGift);
      fetch(`${COACH_CONFIG.apiBaseUrl}/gifts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(giftData)
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setGiftSubmitted(true);
            localStorage.removeItem('pendingGift');
          } else {
            setError(data.error || 'Gift notification failed.');
          }
        })
        .catch(() => setError('Gift notification failed.'));
    }
    setLoading(false);
  }, [searchParams]);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow flex flex-col items-center justify-center py-20">
        {loading ? (
          <div>Loading...</div>
        ) : error ? (
          <div className="text-red-600">{error}</div>
        ) : (
          <div className="text-center">
            <h1 className="text-3xl font-bold text-green-600 mb-4">Payment Successful! 🎉</h1>
            <p className="text-lg text-gray-700 mb-6">
              Thank you for your purchase. Your payment was successful.
            </p>
            {giftSubmitted && (
              <p className="text-green-700 mb-4">Check your email for confirmation!</p>
            )}
            {/* <p className="text-gray-500 mb-2">Session ID: {session}</p> */}
            <a href="/" className="text-sky-600 hover:underline">Return to Home</a>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default PaymentSuccess; 